import { truncateMiddle } from "./string.utils";

export const formatAddress = (
  address: string | undefined,
  startLength = 6,
  endLength = 4,
) => {
  return address ? truncateMiddle(address, startLength, endLength) : "";
};
